<template>
  <div>
    <default-dialog ref="dialog" fullscreen :loading="loading.economic_group">
      <template slot="title">
        Detalhes do Grupo Econômico
      </template>
      <template slot="content">
        <v-expansion-panels v-model="expansion_panels" multiple flat active-class="elevation-4" popout>
          <v-expansion-panel class="exp-panel" ripple>
            <v-expansion-panel-header class="red--text font-weight-bold">
              <div>
                <v-icon size="19" color="red">mdi-information</v-icon>
                Informações básicas
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-title class="d-flex align-center justify-end">
                </v-card-title>
                <v-card-text>
                  <div>
                    <v-col cols='12' class="d-flex justify-end">
                      <f-btn edit small class="ml-2" @click="dialog.name = true"></f-btn>
                    </v-col>
                    <DialogEditEconomicGroupName
                      :dialog="dialog.name" 
                      :model_economic_group="economic_group"
                      @closeDialog="dialog.name = false"
                      @updated="handleRefresh"
                    ></DialogEditEconomicGroupName>
                    <EconomicGroupForm :economic_group="economic_group" read_only ></EconomicGroupForm>
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="exp-panel" ripple>
            <v-expansion-panel-header class="red--text font-weight-bold">
              <div>
                <v-icon size="19" color="red">mdi-account-group</v-icon>
                Clientes do Grupo
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-title class="d-flex align-center justify-end">
                </v-card-title>
                <v-card-text>
                  <div>
                    <v-col cols='12' class="d-flex justify-end">
                      <f-btn edit small class="ml-2" @click="dialog.clients = true"></f-btn>
                    </v-col>
                    <DialogEditEconomicGroupClients
                      :dialog="dialog.clients" 
                      :model_economic_group="economic_group"
                      @closeDialog="dialog.clients = false"
                      @updated="handleRefresh"
                    ></DialogEditEconomicGroupClients>
                    <EconomicGroupClientsForm :economic_group="economic_group" read_only ></EconomicGroupClientsForm>
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel class="exp-panel" ripple>
            <v-expansion-panel-header class="red--text font-weight-bold">
              <div>
                <v-icon size="19" color="red">mdi-credit-card</v-icon>
                Crédito do Grupo
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-title class="d-flex align-center justify-end">
                </v-card-title>
                <v-card-text>
                  <div>
                    <v-col cols='12' class="d-flex justify-end">
                      <f-btn edit small class="ml-2" @click="dialog.credit = true"></f-btn>
                    </v-col>
                    <DialogEditEconomicGroupCredit
                      :dialog="dialog.credit" 
                      :model_economic_group="economic_group"
                      @closeDialog="dialog.credit = false"
                      @updated="handleRefresh"
                    ></DialogEditEconomicGroupCredit>
                    <EconomicGroupBlockAlert 
                      v-if="economic_group.economic_group_credit"
                      :economic_group_credit="economic_group.economic_group_credit"
                      :economic_group="economic_group"
                      @credit_updated="handleRefresh"
                      @successSaved="handleRefresh"
                    ></EconomicGroupBlockAlert>
                    <EconomicGroupCreditForm 
                      :credit="economic_group.economic_group_credit?.data?.attributes" 
                      read_only 
                    ></EconomicGroupCreditForm>
                  </div>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>

        </v-expansion-panels>
      </template>
      <template slot="actions">
        <f-btn close @click="goBack()"></f-btn>
      </template>
    </default-dialog>
    <dialog-loading v-if="saving" loadingText="Salvando..."></dialog-loading>
  </div>
</template>


<script>
import Api from '@/api/index';

export default {
  name: "ShowEconomicGroup",
  components: {
    EconomicGroupForm: ()=> import("@/_backoffice/_registrations/components/economic_groups/forms/EconomicGroupForm.vue"),
    EconomicGroupClientsForm: ()=> import("@/_backoffice/_registrations/components/economic_groups/forms/EconomicGroupClientsForm.vue"),
    EconomicGroupCreditForm: ()=> import("@/_backoffice/_registrations/components/economic_groups/forms/EconomicGroupCreditForm.vue"),
    EconomicGroupBlockAlert: ()=> import("@/_backoffice/_registrations/components/shared/client_block/EconomicGroupBlockAlert.vue"),
    DialogEditEconomicGroupName: () => import('@/_backoffice/_registrations/components/economic_groups/DialogEditEconomicGroupName.vue'),
    DialogEditEconomicGroupClients: () => import('@/_backoffice/_registrations/components/economic_groups/DialogEditEconomicGroupClients.vue'),
    DialogEditEconomicGroupCredit: () => import('@/_backoffice/_registrations/components/economic_groups/DialogEditEconomicGroupCredit.vue'),
  },
  data() {
    return {
      saving: false,
      dialog: {
        name: false,
        clients: false,
        credit: false,
      },
      loading: {
        economic_group: false,
      },
      expansion_panels: [0, 1, 2],
      economic_group: {},
    }
  },
  methods: {
    getData(){
      this.$refs.dialog.openDialog()
      this.getEconomicGroup()
    },
    handleRefresh(){
      this.dialog.name = false
      this.dialog.clients = false
      this.dialog.credit = false
      this.getData()
    },
    getEconomicGroup(){
      this.loading.economic_group = true
      let id = this.$route.params.id
      Api.EconomicGroup.show(id).then((res)=>{
        // Converte do formato JSON:API para formato simples
        const data = res.data.data
        this.economic_group = {
          id: data.id,
          name: data.attributes?.name,
          client_ids: data.attributes?.client_ids || [],
          economic_group_credit: data.attributes?.economic_group_credit,
          ...data.attributes
        }
      }).finally(()=>{
        this.loading.economic_group = false
      })
    },
    goBack(){
      this.$router.push({name:"EconomicGroups"})
    },
  },
  mounted() {
    this.getData();
  },
}
</script>

